import { StrictDict } from '@edx/react-unit-test-utils';

export default StrictDict({
  modalClose: 'plugin.modal-close',
  modalOpen: 'plugin.modal',
});
